<div class="container">
  <div class="insomnia_inner">
    <div class="row">

      <div class="col-md-8">

        <div class="side_title insomnia">
          <h1>
            Game Information
          </h1>
        </div>
        <p>
        <li>Solo play</li>
        <li>One tournament per day</li>
        <li>Single Elimination Bracket Groups - BO1</li>
        <!--<li>Single Elimination Semi-finals & final - BO3</li>-->
        </p>

      </div>

      <div class="col-md-4">

        <div class="side_title insomnia">
          <h1>
            Prizes:
          </h1>
        </div>

        <p>
        <li>1st place: 15,000 EGP </li>
        <li>2nd place: 7,500 EGP </li>
        </p>

      </div>

    </div>

    <div class="row">

      <div class="col-md-12">
        <div class="side_title insomnia">
          <h1>
            Timing
          </h1>
        </div>
        <p><strong>Friday</strong> 12:00pm</p>
        <p><strong>Saturday</strong> 12:00pm</p>

      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="side_title insomnia">
          <h1>Registration & Tickets</h1>
        </div>
        <p>If you wish to participate in the fifa tournament, you will have to purchase a one day ticket.</p>
        <a href="https://tickets.virginmegastore.me/eg/others/6227/insomnia-egypt?ref=list" target="_blank"
           class="go_button sm orange square">
          <i class="icon-ticket"></i> Buy Ticket
        </a>

        <p>We recommend you read over the terms and conditions which you can find <a href="https://www.insomniagamingegypt.com/termsandconditions/" target="_blank">here</a></p>

      </div>
    </div>


  </div>

</div>
